import { STRING } from "../constants/string";

/* Every caller in the app reads a failure as `error?.data?.message` — that is
   the axios *response* object, which the service layer rejects with. But axios
   only attaches `response` when the server actually answered. Offline, DNS
   failures, CORS rejections and the 10s timeout all arrive with `response`
   undefined, so the message came out `undefined`, Utils.toast dropped it, and
   the request failed in total silence.

   This keeps that one contract intact: whatever went wrong, the rejection
   always carries `.data.message`. */
export const normalizeApiError = (error) => {
  if (error?.response) return error.response;

  const isTimeout =
    error?.code === "ECONNABORTED" || /timeout/i.test(error?.message || "");

  return {
    status: 0,
    data: {
      status: 0,
      message: isTimeout ? STRING.REQUEST_TIMEOUT : STRING.NETWORK_ERROR,
      data: {},
    },
  };
};

/* A session is only usable if it carries a non-blank token. The API is strict
   about the header it is put into:

     access_token ""          -> "Basic"            -> 401 Wrong authorization header format
     access_token undefined   -> "Basic undefined"  -> 401 Authentication failed

   Both are the same client bug - there is no session - so the request is worth
   failing before it leaves the browser. */
export const hasAuthToken = (access_token) =>
  String(access_token ?? "").trim().length > 0;

export const missingTokenError = () => ({
  status: 401,
  data: {
    status: 401,
    message: STRING.SESSION_EXPIRED,
    data: {},
  },
});

export default normalizeApiError;
